import firebase from "firebase/app";
import React, { Fragment, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useList } from "react-firebase-hooks/database";
import { MdShowChart } from "react-icons/md";
import LoadingOverlay from "react-loading-overlay";
import { Button, Col, FormGroup, FormSelect, Row } from "shards-react";
import ReactTable from "../Reports/ReactTable";
import { getAgeGroupData, getComplaintTypesData } from "./getChartData";
import sectors from "./sectors.json";

export const Timeline2 = () => {
  const currentYear = new Date().getFullYear();
  const YEARS = Array.from({ length: 5 }, (_, index) => currentYear - index);

  const [options, setOptions] = useState({
    chart: {
      type: "bar",
      toolbar: {
        show: true,
      },
      id: "Total complaints",
      background: "#f4f4f4",
      foreColor: "#333",
    },
    plotOptions: {
      bar: {},
    },
    animations: {
      enabled: true,
      easing: "easeinout",
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    },
    toolbar: {
      show: true,
    },
    xaxis: {},
    yaxis: {
      title: {
        text: "tickets",
      },
    },
  });

  const [filter, setFilter] = useState({
    query: "sector",
    sector: "",
    category: "",
    complaintType: "",
    chartType: "bar",
    year: currentYear,
  });

  const [series, setSeries] = useState([]);
  const [pieSeries, setPieSeries] = useState([]);

  const [title, setTitle] = useState("");

  const [snapshots, loading, error] = useList(
    firebase.database().ref("complaints/" + filter.year)
  );

  const getChartData = useMemo(() => {
    return getComplaintTypesData(snapshots, filter.sector);
  }, [JSON.stringify(snapshots), filter.sector, filter.query]);

  const getPieData = useMemo(() => {
    return getAgeGroupData(snapshots, filter.sector);
  }, [JSON.stringify(snapshots), filter.sector, filter.query]);

  const updateCharts = () => {
    let title = `Total complaints received in ${filter.year} for ${filter.sector}`;
    setSeries(getChartData.series);
    setPieSeries(getPieData.series);
    setOptions({
      ...options,
      chart: {
        ...options.chart,
        type: filter.chartType,
      },
      title: { text: title, align: "center" },
      series: getChartData.series,
      xaxis: { categories: getChartData.categories },
    });

    setTimeout(() => {}, 1000);
  };

  const getTableData = () => {
    return (
      getChartData.data
        ?.filter((complaint) => complaint.val().status !== "cancelled")
        .map((complaint) => complaint.val()) || []
    );
  };

  return (
    <Fragment>
      {loading && <LoadingOverlay active={loading} spinner />}
      <Row>
        {/* <Col>
          <FormGroup>
            <label htmlFor="chartType">ChartType</label>
            <FormSelect
              name="chartType"
              value={filter.chartType}
              onChange={(e) => {
                setFilter({ ...filter, chartType: e.target.value });
              }}
            >
              <option value="line">Line</option>
              <option value="bar">Bar</option>
            </FormSelect>
          </FormGroup>
        </Col> */}

        <Col>
          <FormGroup>
            <label htmlFor="year">Year</label>
            <FormSelect
              name="year"
              value={filter.year}
              onChange={(e) =>
                setFilter({ ...filter, year: parseInt(e.target.value) })
              }
            >
              {YEARS.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <label htmlFor="query">Sector</label>
            <FormSelect
              name="sector"
              value={filter.sector}
              onChange={(e) => setFilter({ ...filter, sector: e.target.value })}
            >
              <option value="">None</option>
              {sectors.map((sector) => {
                return (
                  <option key={sector} value={sector}>
                    {sector}
                  </option>
                );
              })}
            </FormSelect>
          </FormGroup>
        </Col>
        <Col>
          <Button onClick={() => updateCharts()}>
            <MdShowChart />
            Plot
          </Button>
        </Col>
      </Row>

      <h4 className="text-center mt-2"> {title}</h4>
      <div id="chart">
        <Chart
          options={options}
          series={series}
          height="600"
          type={filter.chartType}
        />
      </div>

      <div id="chart2">
        <Chart
          options={{
            chart: {
              type: "pie",
              toolbar: {
                show: true,
              },
            },

            title: {
              text: `${filter.sector} by age group`,
              align: "center",
            },
            labels: getPieData.categories,
            dataLabels: {
              enabled: true,
            },
          }}
          type="pie"
          series={pieSeries}
          height="600"
        />
      </div>

      {getTableData().length > 0 && (
        <ReactTable
          data={getTableData()}
          filename={`${filter.sector}-${filter.year}.csv`}
        />
      )}
    </Fragment>
  );
};
